export const LOTTO_OVERLAYS_ID = 'lotto-overlays';
